import { createSlice } from "@reduxjs/toolkit";
import {
  getUser,
  loginUser,
  registerUser,
  subscribeTrack,
} from "../apis/users";
import TokenUserServices from "../../api-config/userStorage";
export const userSlice = createSlice({
  name: "users",
  initialState: { user: {}, isLogged: false },
  reducers: {
    logoutUser: (state) => {
      state.isLogged = false;
      state.user = {};
    },
  },
  extraReducers: {
    [loginUser.fulfilled]: (state, { payload }) => {
      state.user = payload.user;
      state.isLogged = true;
      localStorage.setItem(
        "user",
        JSON.stringify({
          token: payload.token,
          user: payload.user._id,
        })
      );
    },
    [registerUser.fulfilled]: (state, { payload }) => {
      state.user = payload;
      state.isLogged = true;
      // const newUser = {
      //   token: payload.token,
      //   user: payload.user._id,
      // };
      // TokenUserServices.updateLocalAccessToken(newUser);
      localStorage.removeItem("user");
      localStorage.setItem(
        "user",
        JSON.stringify({
          token: payload.token,
          user: payload.user._id,
        })
      );
    },
    [getUser.fulfilled]: (state, { payload }) => {
      state.user = payload.user;
      state.isLogged = true;
    },
    [subscribeTrack.fulfilled]: (state, { payload }) => {
      state.user = payload.UpdatedUser;
    },
  },
});

export const { logoutUser } = userSlice.actions;
const { reducer } = userSlice;
export default reducer;
